import { render } from "./WithdrawDetail.vue?vue&type=template&id=078039fa"
import script from "./WithdrawDetail.vue?vue&type=script&lang=js"
export * from "./WithdrawDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__